import { render, staticRenderFns } from "./DashBoardPanel.vue?vue&type=template&id=68c013d2&scoped=true"
import script from "./DashBoardPanel.vue?vue&type=script&lang=ts"
export * from "./DashBoardPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./DashBoardPanel.vue?vue&type=style&index=0&id=68c013d2&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "68c013d2",
  null
  ,true
)

export default component.exports